import { create } from "zustand";

interface ExampleState {
  selectedIds: string[];
  searchQuery: string;
  setSelectedIds: (ids: string[]) => void;
  toggleSelection: (id: string) => void;
  clearSelection: () => void;
  setSearchQuery: (query: string) => void;
  reset: () => void;
}

const initialState = {
  selectedIds: [] as string[],
  searchQuery: "",
};

export const useExampleStore = create<ExampleState>((set) => ({
  ...initialState,
  setSelectedIds: (ids) => set({ selectedIds: ids }),
  toggleSelection: (id) =>
    set((state) => {
      const isSelected = state.selectedIds.includes(id);
      return {
        selectedIds: isSelected
          ? state.selectedIds.filter((x) => x !== id)
          : [...state.selectedIds, id],
      };
    }),
  clearSelection: () => set({ selectedIds: [] }),
  setSearchQuery: (query) => set({ searchQuery: query }),
  reset: () => set(initialState),
}));
